export default "__VITE_ASSET__112f6e9b__"